export const crapienv = {
    IDENTITY_SERVICE: "identity/",
    WORKSHOP_SERVICE: "workshop/",
    CHATBOT_SERVICE: "chatbot/",
    COMMUNITY_SERVICE: "community/",
    CHATBOT_SERVICE: "chatbot/",
};

